angular
  .module("calcoloIrap.components", [])
  .component("calcoloIrap", {
    templateUrl: "ng/components/calcoloIrap/calcoloIrap.view.html",
    bindings: {},
    controllerAs: "calcoloIrapCtrl",
    controller: function CalcoloIrap(
      $location,
      $arcService,
      $modalService,
      $transactionFactory,
      $RichiestePostVenditaService,
      $financialApiService,
      RichiestePostVendita
    ) {
      var self = this;
      self.$onInit = function () {
        self.isPending = true;
        self.ctrRichiestaList = [];

        self.filterAllContracts = {
          appContract: {
            limit: "10",
            offset: 0,
            pageIndex: 1,
            totalPages: 0,
            annoRiferimentoIrap: null
          }
        }
        self.modelToPopulateDropDowns = {
          numeriContratti: [],
          listaProdotti: [],
          statoPratiche: [],
          annoRiferimentoIrap: []
        }
        self.getContractList();
      }

      self.getContractList = function (filter) {
        if (!filter) {
          filter = self.filterAllContracts.appContract;
        }
        $arcService
          .getIrap(filter)
          .then(function (response) {
            self.metadata = response;
            if (self.metadata.success == true) {
              var totalCount = response.totaleContratti;
              self.filterAllContracts.appContract.totalPages = Math.ceil(
                response.totaleContratti / 10
              );
              self.isPending = false;
              self.populateDropDowns();


              if (self.metadata.listContratti == 0) {
                self.nothingToShow = true;
              } else {
                self.nothingToShow = false;
              }
              getSTotalPages(totalCount);
            }
          }).catch(function (error) {
            console.log(error);
            self.isPending = false;
          });
      }

      self.populateDropDowns = function () {
        self.modelToPopulateDropDowns.statoPratiche = self.metadata.listStatus;
        self.modelToPopulateDropDowns.annoRiferimentoIrap = self.metadata.listYears;
        self.modelToPopulateDropDowns.listaProdotti = self.metadata.listProducts;
        self.modelToPopulateDropDowns.statoPratiche = self.modelToPopulateDropDowns.statoPratiche.map(function (element) {
          return {
            dscFaseGestionale: element.description
          }
        })
      }

      self.check = function (el) {
        el.selected = !el.selected;
        self.ctrRichiestaList = self.metadata.listContratti.filter(function (element) {
          return element.selected == true;
        })
      }

      self.checkSelected = function () {
        return self.metadata.listContratti.some(function (element) {
          return element.selected == true
        })
      }

      self.showModal = function () {
        self.showLoader = true;
        var input = {
          metadata: {
            ctrRichiestaList: []
          }
        }
        self.ctrRichiestaList.forEach(x => {
          input.metadata.ctrRichiestaList.push(x)
        })
        $RichiestePostVenditaService.showSpesaIrap(input)
          .then(function (response) {
            if (response.success) {
              self.message = response.message;
              self.listaSpese = response.spese;
              $modalService.openModal("showSpesa")
            }
            self.showLoader = false;
          })
          .catch(function (error) {
            console.log(error);
            self.showLoader = false;
          })
      }

      self.closeModal = function (id) {
        $modalService.closeModal(id);
      }

      self.openDettagliCalcolo = function (contratto) {
        $transactionFactory.set(contratto);
        $location.path("/dettagliCalcolo");
      }

      self.requestCalcIrap = function () {
        self.showLoaderModal = true;
        $arcService
          .requestIrap(self.ctrRichiestaList)
          .then(function (response) {
            self.richiestaIrap = response;
            self.ctrRichiestaList = [];
            self.getContractList();
            self.showLoaderModal = false;
            $modalService.closeModal('showSpesa');
          })
          .catch((error) => {
            console.log(error);
            self.showLoaderModal = false;
          })
        self.isPending = true;
      }

      self.onPressSearch = function (filter) {
        self.isPending = true;
        self.filterAllContracts.appContract = filter;
        Object.assign(self.filterAllContracts.appContract, {
          limit: "10",
          offset: 0,
          pageIndex: 1,
          totalPages: 0
        })
        if (filter.product) {
          filter.product = filter.product.id
        }
        if (filter.annoRiferimentoIrap) {
          filter.annoRiferimentoIrap = filter.annoRiferimentoIrap.id;
        }
        self.getContractList(filter);
      }

      self.openDettaglioCruscotto = function (id) {
        //self.loaderDettaglioPv[index] = true;

        $financialApiService.dettaglioRichiestaPv(id)
          .then(function (response) {
            //self.loaderDettaglioPv[index] = false;
            response.readOnly = true;
            var richiestePostVenditaModel = RichiestePostVendita.build(response);
            $transactionFactory.set(richiestePostVenditaModel);
            $location.path('/dettaglioCruscottoRichiestaClienti')
          })
          .catch(function () {
            //self.loaderDettaglioPv[index] = false;
          })
      }

      self.pageSIndexIndietro = function (value) {
        self.isPending = true;
        if (value == "init") {
          self.filterAllContracts.appContract.pageIndex = 1;
        } else {
          if (self.filterAllContracts.appContract.pageIndex > 1) {
            self.filterAllContracts.appContract.pageIndex--;
          }
        }
        updateOffsetAndSearch();
      };

      self.pageSIndexAvanti = function (value) {
        self.isPending = true;
        if (value == "end") {
          //subito pagina finale
          self.filterAllContracts.appContract.pageIndex =
            self.filterAllContracts.appContract.totalPages;
        } else {
          //avanzo +1
          if (
            self.filterAllContracts.appContract.pageIndex <
            self.filterAllContracts.appContract.totalPages
          ) {
            self.filterAllContracts.appContract.pageIndex++;
          }
        }
        updateOffsetAndSearch();
      };

      function updateOffsetAndSearch() {
        self.filterAllContracts.appContract.offset =
          (self.filterAllContracts.appContract.pageIndex - 1) *
          self.filterAllContracts.appContract.limit;

        self.getContractList(self.filterAllContracts.appContract);
      }

      function getSTotalPages(totalCount) {
        //se il resto Ã¨ zero non va aggiunto +1
        var addPlusOneToTotal = 0;
        var totModuloResult =
          totalCount % Number(self.filterAllContracts.appContract.limit);
        if (totModuloResult > 0) {
          addPlusOneToTotal = 1;
        }
        return (
          Math.floor(
            totalCount / Number(self.filterAllContracts.appContract.limit)
          ) + addPlusOneToTotal
        );
      }
    }
  });